import * as _ from 'lodash'
import { PortfolioRepo as portfolioRepo } from '@services/portfolio.repo';
import {ReportingService as reportingService} from '@common/reporting.service'
import * as moment from 'moment'
import { ReportingParams } from '../reporting/reportingParams';
import { IS_RECONCILED_FLAG } from '@constants/reporting';

class IdName {
  constructor(public id: number, public name: string) { }
}

class IdNameSources {
  public source: string;
  constructor(public id: number, public name: string, sources: Array<IdName>) {
    this.source = _.orderBy(_.keys(_.groupBy(sources, (s: any) => { return s.name })), (s) => { return s }).join(",");
  }
}


export class portfolioSelectorService {
  private potentialPortfolios: Array<IdNameSources>;
  private selectedPortfolios: Array<number>;
  private selectedCurrency : string;
  private sources: Array<string>;

  private childCallbacks: Map<string, Map<string, () => any>>;

  public isLoading : boolean = false;

  /** @ngInject */
  constructor(private $state: angular.ui.IStateService, private portfolioRepo: portfolioRepo, private reportingService : reportingService, private notifyjs) {
    this.childCallbacks = new Map<string, Map<string, () => any>>();
  }

  public getUserPortfolios() {
    return this.portfolioRepo.getUserPortfolios()
      .then(res => {
        this.potentialPortfolios = [];
        this.selectedPortfolios = [];

        let clients = res.data as Array<any>;
        if (clients && clients.length) {
          _.forEach(clients, client => {
            if (client['portfolios'] && client['portfolios'].length) {
              _.forEach(client['portfolios'] as Array<any>, (portfolio) => {
                if (portfolio['sources'] == null || portfolio['sources'] == "")
                  portfolio['sources'] = [{name : 'Unknown'}];

                this.potentialPortfolios.push(new IdNameSources(portfolio['id'], portfolio['name'], portfolio['sources']));
                this.selectedPortfolios.push(portfolio['id']);
              })
            }
          })
        }
        this.sources = _.orderBy(_.keys(_.groupBy(this.potentialPortfolios, (p) => { return p.source })), (source) => { return source });

        return this.potentialPortfolios;
      })
  }

  public getPotentialPortfolios() {
    return this.potentialPortfolios;
  }

  public getSelectedPortfolios() {
    return this.selectedPortfolios;
  }

  public getSelectedCurrency(){
    return this.selectedCurrency;
  }

  public setSelectedPortfolios(updatedSelection: Array<number>) {
    this.selectedPortfolios = updatedSelection;
    this.notifyCallbacks();
  }

  public setCurrency(updatedCurrency: string) {
    this.selectedCurrency = updatedCurrency;
    this.notifyCallbacks();
  }

  public getSources() {
    return this.sources;
  }

  public registerCallback(page, callback) {
    let state = this.$state.current.name;
    if (!this.childCallbacks.has(state))
      this.childCallbacks.set(state, new Map<string, () => any>());

    let map = this.childCallbacks.get(state);
    map.set(page, callback);
  };

  private notifyCallbacks() {
    let state = this.$state.current.name;
    if (this.childCallbacks.has(state)) {
      let map = this.childCallbacks.get(state);
      let keysIterator = map.keys();

      let keyIterator = keysIterator.next();

      while (!keyIterator.done) {
        let page = keyIterator.value;
        let callback = map.get(page);
        callback();

        keyIterator = keysIterator.next();
      };
    }
  }

  public setIsLoading(isLoading : boolean){
    this.isLoading = isLoading;
  }

  public generateAdHocReport (isReconciled:boolean){
    this.isLoading = true
    let yesterday = moment().add(-1, 'days').format('YYYY-MM-DD')
    
    const reportingParams = new ReportingParams();
    reportingParams.reportType = "portfoliosummary";
    reportingParams.currency = this.selectedCurrency
    reportingParams.fromDate = null;
    reportingParams.toDate = yesterday;
    reportingParams.portfolioIds = this.selectedPortfolios;
    reportingParams.displayLocalPerformance = true;
    reportingParams.displayInternationalPerformance = true;
    reportingParams.displayMonthlyPerformance = false;
    reportingParams.displayLineItems = true;
    reportingParams.isReconciled = isReconciled;

    this.reportingService.generateReport(reportingParams)
    .then((res) => {
      this.isLoading = false
    })
    .catch(() => {
      this.isLoading = false
      this.notifyjs("The report could not be generated. Please try again later or contact the System Administrator for assistance.", "error");
    });
  }


}

class PortfolioSelector {
  private selectedPortfolios: Array<number>;
  private currencyList: Array<string>;
  private selectedCurrency : string = "MUR"
  private isReconciled: boolean;
  /** @ngInject */
  constructor(private portfolioSelectorService: portfolioSelectorService) {
    this.selectedPortfolios = this.portfolioSelectorService.getSelectedPortfolios();
    this.currencyList = ["MUR", "EUR", "GBP", "USD", "CHF"];
    this.portfolioSelectorService.setCurrency(this.selectedCurrency);
    this.isReconciled = sessionStorage.getItem(IS_RECONCILED_FLAG) === "true";
  }

  public clientHasPortfolios() {
    return this.portfolioSelectorService.getPotentialPortfolios().length != 0;
  }

  public getPotentialPortfolios() {
    return this.portfolioSelectorService.getPotentialPortfolios();
  }

  public getSources() {
    return this.portfolioSelectorService.getSources();
  }

  public getSelectedText() {
    if (this.selectedPortfolios.length == this.getPotentialPortfolios().length)
      return "All My Portfolios";

    return `${this.selectedPortfolios.length} of ${this.getPotentialPortfolios().length} Portfolios`;

  }

  public onSelectClose() {
    this.portfolioSelectorService.setSelectedPortfolios(this.selectedPortfolios);
  }
  public onSelectCurrencyClose() {
    this.portfolioSelectorService.setCurrency(this.selectedCurrency);
  }
  public generateReport(){
    this.portfolioSelectorService.generateAdHocReport(this.isReconciled)
  }

}

export const portfolioSelector: angular.IComponentOptions = {
  template: require('./portfolioSelector.html'),
  controller: PortfolioSelector,
}



// WEBPACK FOOTER //
// ./src/app/portfolio/portfolioSelector.ts